/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Booking'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import { eventBus } from '../../../main';
import { CONF_API_BASEURL } from '../../../config';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> 'Covid Text ------------------------------------
    covidtext_DE: [],
    covidtext_EN: [],

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Website' - 'Covid Text'
    ***************************************************************************/
    /***************************************************************************
    * get_CovidText_DE()
    *
    * Desc: Return 'DE' Version of Covid Text.
    * Note:
    *
    */
    get_CovidText_DE: state => {

        return state.covidtext_DE;

    }, // eof get_CovidText_DE()


    /***************************************************************************
    * get_CovidText_EN()
    *
    * Desc: Return 'EN' Version of Covid Text.
    * Note:
    *
    */
    get_CovidText_EN: state => {

        return state.covidtext_EN;

    }, // eof get_CovidText_EN()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'Website' - 'Covid Text'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getCovidText()
    *
    * Desc: Save 'Covid Text' to state.
    * Note: Gettin 'lang' via payload.
    *
    */
    mut_call_getCovidText: (state, payload) => {

        if (payload.lang === 'de') {
            state.covidtext_DE = payload.response;
        }

        if (payload.lang === 'en') {
            state.covidtext_EN = payload.response;
        }

    }, // eo function mut_call_getCovidText()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Website' - 'Covid Text'
    ***************************************************************************/
    /***************************************************************************
    * Call: 'actn_call_getCovidText'
    *
    * Desc: Get 'Covid Text'.
    * Note: Gettin 'lang' in payload.
    *
    */
    actn_call_getCovidText: (context, payload) => {

        // Vue.prototype.$vp_m();
        axios.post(CONF_API_BASEURL, payload.payload)
            .then(function (response) {
                // Vue.prototype.$vp_um();
                context.commit('mut_call_getCovidText', { response: response.data.data.covid, lang: payload.lang });
            })
            .catch(function (error) {
                // Vue.prototype.$vp_um();


                // >>> --------------------------
                if (error.response && error.response.data.errors) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: error.response.data.errors[0].message
                    });
                } else {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: "Service not available"
                    });
                }
            });

    }, // eo funtion actn_call_getCovidText()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/covid/covid.js